import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
export const Terms = () => {
  return <section className="w-full bg-white py-16" data-id="element-253">
      <div className="max-w-4xl mx-auto px-4" data-id="element-254">
        <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-8" data-id="element-255">
          <ArrowLeft className="h-4 w-4 mr-2" data-id="element-256" />
          Back to Home
        </Link>
        <article className="prose prose-lg max-w-none" data-id="element-257">
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-258">
            EndorseHive Terms & Conditions
          </h1>
          <p className="text-gray-600 italic text-center mb-12" data-id="element-259">
            Effective Date: 1 February 2025
          </p>
          <div className="space-y-12" data-id="element-260">
            {/* 1. Introduction */}
            <section data-id="element-261">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-262">
                1. Introduction
              </h2>
              <div className="space-y-6" data-id="element-263">
                <div data-id="element-264">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-265">
                    1.1 Legal Entity & Contact Information
                  </h3>
                  <p className="text-gray-600" data-id="element-266">
                    These Terms & Conditions ("Terms") govern your use of the{" "}
                    <strong data-id="element-267">EndorseHive</strong> platform (the "Service"),
                    operated by <strong data-id="element-268">LeanOps LLC</strong>, located at{" "}
                    <em data-id="element-269">16192 Coastal Hwy, Lewes, Delaware 19958</em>. For any
                    questions or concerns about these Terms, please contact us
                    at{" "}
                    <a href="mailto:support@endorsehive.com" className="text-emerald-600 hover:text-emerald-700" data-id="element-270">
                      support@endorsehive.com
                    </a>
                    .
                  </p>
                </div>
                <div data-id="element-271">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-272">
                    1.2 Acceptance of Terms
                  </h3>
                  <p className="text-gray-600" data-id="element-273">
                    By accessing or using the Service, you agree to be bound by
                    these Terms. If you do not agree, you must discontinue use
                    of the Service immediately.
                  </p>
                </div>
                <div data-id="element-274">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-275">
                    1.3 Governing Law & Jurisdiction
                  </h3>
                  <p className="text-gray-600" data-id="element-276">
                    These Terms are governed by the laws of the{" "}
                    <strong data-id="element-277">State of Delaware</strong>, without regard to its
                    conflict of laws principles. All disputes arising under or
                    in relation to these Terms shall be resolved in the state or
                    federal courts located in Delaware.
                  </p>
                </div>
              </div>
            </section>
            {/* 2. The Service & Scope */}
            <section data-id="element-278">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-279">
                2. The Service & Scope
              </h2>
              <div className="space-y-6" data-id="element-280">
                <div data-id="element-281">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-282">
                    2.1 Nature of Service
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-283">
                    EndorseHive is a platform through which micro-influencers
                    ("Influencers") can earn monthly compensation by granting
                    EndorseHive privacy-safe access to their LinkedIn profiles.
                    Our AI agents use this access to:
                  </p>
                  <ul className="list-disc pl-6 text-gray-600 space-y-1" data-id="element-284">
                    <li data-id="element-285">Re-share brand postings</li>
                    <li data-id="element-286">Connect with new users</li>
                    <li data-id="element-287">Send messages to those new connections</li>
                    <li data-id="element-288">
                      Promote selected solutions while preserving each
                      Influencer's professional image
                    </li>
                  </ul>
                </div>
                <div data-id="element-289">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-290">
                    2.2 No Fees for Influencers
                  </h3>
                  <p className="text-gray-600" data-id="element-291">
                    Influencers do not pay fees to use or participate in the
                    Service. Compensation is offered to Influencers who maintain
                    active campaigns.
                  </p>
                </div>
              </div>
            </section>
            {/* 3. Eligibility */}
            <section data-id="element-292">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-293">
                3. Eligibility
              </h2>
              <div className="space-y-6" data-id="element-294">
                <div data-id="element-295">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-296">
                    3.1 Eligible Influencers
                  </h3>
                  <p className="text-gray-600" data-id="element-297">
                    To participate in the Service, you must be a
                    micro-influencer with a verified LinkedIn profile and a
                    minimum of 1000 followers.
                  </p>
                </div>
                <div data-id="element-298">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-299">
                    3.2 Eligible Campaigns
                  </h3>
                  <p className="text-gray-600" data-id="element-300">
                    You must have a valid campaign that meets EndorseHive's
                    criteria for eligibility.
                  </p>
                </div>
              </div>
            </section>
            {/* 4. Compensation */}
            <section data-id="element-301">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-302">
                4. Compensation
              </h2>
              <div className="space-y-6" data-id="element-303">
                <div data-id="element-304">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-305">
                    4.1 Compensation Amount
                  </h3>
                  <p className="text-gray-600" data-id="element-306">
                    Influencers will receive a monthly compensation of $500 for
                    each active campaign.
                  </p>
                </div>
                <div data-id="element-307">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-308">
                    4.2 Payment Method
                  </h3>
                  <p className="text-gray-600" data-id="element-309">
                    Compensation will be paid via direct deposit to your bank
                    account.
                  </p>
                </div>
              </div>
            </section>
            {/* 5. Privacy */}
            <section data-id="element-310">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-311">
                5. Privacy
              </h2>
              <div className="space-y-6" data-id="element-312">
                <div data-id="element-313">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-314">
                    5.1 Data Collection
                  </h3>
                  <p className="text-gray-600" data-id="element-315">
                    EndorseHive collects personal information about Influencers,
                    including their LinkedIn profile information and contact
                    details.
                  </p>
                </div>
                <div data-id="element-316">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-317">5.2 Data Use</h3>
                  <p className="text-gray-600" data-id="element-318">
                    EndorseHive uses the collected data to provide the Service
                    and to improve the platform.
                  </p>
                </div>
                <div data-id="element-319">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-320">
                    5.3 Data Security
                  </h3>
                  <p className="text-gray-600" data-id="element-321">
                    EndorseHive takes appropriate measures to protect the
                    collected data from unauthorized access or disclosure.
                  </p>
                </div>
              </div>
            </section>
            {/* 6. User Conduct */}
            <section data-id="element-322">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-323">
                6. User Conduct
              </h2>
              <div className="space-y-6" data-id="element-324">
                <div data-id="element-325">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-326">
                    6.1 No Misuse of Service
                  </h3>
                  <p className="text-gray-600" data-id="element-327">
                    You agree not to use the Service for any purpose that
                    violates the laws of any jurisdiction.
                  </p>
                </div>
                <div data-id="element-328">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-329">
                    6.2 No Unauthorized Access
                  </h3>
                  <p className="text-gray-600" data-id="element-330">
                    You agree not to attempt to gain unauthorized access to the
                    Service or to any of its associated systems.
                  </p>
                </div>
                <div data-id="element-331">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-332">
                    6.3 No Spam or Harassment
                  </h3>
                  <p className="text-gray-600" data-id="element-333">
                    You agree not to send unsolicited messages or engage in any
                    form of harassment or discrimination.
                  </p>
                </div>
              </div>
            </section>
            {/* 7. Termination */}
            <section data-id="element-334">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-335">
                7. Termination
              </h2>
              <div className="space-y-6" data-id="element-336">
                <div data-id="element-337">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-338">
                    7.1 Termination by EndorseHive
                  </h3>
                  <p className="text-gray-600" data-id="element-339">
                    EndorseHive may terminate your access to the Service at any
                    time, with or without cause.
                  </p>
                </div>
                <div data-id="element-340">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-341">
                    7.2 Termination by Influencer
                  </h3>
                  <p className="text-gray-600" data-id="element-342">
                    You may terminate your access to the Service at any time,
                    with or without cause.
                  </p>
                </div>
              </div>
            </section>
            {/* 8. Dispute Resolution */}
            <section data-id="element-343">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-344">
                8. Dispute Resolution
              </h2>
              <div className="space-y-6" data-id="element-345">
                <div data-id="element-346">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-347">
                    8.1 Mediation
                  </h3>
                  <p className="text-gray-600" data-id="element-348">
                    Any dispute arising under or in relation to these Terms
                    shall be resolved through mediation.
                  </p>
                </div>
                <div data-id="element-349">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-350">
                    8.2 Arbitration
                  </h3>
                  <p className="text-gray-600" data-id="element-351">
                    If mediation is unsuccessful, any dispute shall be resolved
                    through arbitration.
                  </p>
                </div>
              </div>
            </section>
            {/* 9. Governing Law & Jurisdiction */}
            <section data-id="element-352">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-353">
                9. Governing Law & Jurisdiction
              </h2>
              <div className="space-y-6" data-id="element-354">
                <div data-id="element-355">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-356">
                    9.1 Governing Law
                  </h3>
                  <p className="text-gray-600" data-id="element-357">
                    These Terms are governed by the laws of the{" "}
                    <strong data-id="element-358">State of Delaware</strong>, without regard to its
                    conflict of laws principles.
                  </p>
                </div>
                <div data-id="element-359">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-360">
                    9.2 Jurisdiction
                  </h3>
                  <p className="text-gray-600" data-id="element-361">
                    All disputes arising under or in relation to these Terms
                    shall be resolved in the state or federal courts located in
                    Delaware.
                  </p>
                </div>
              </div>
            </section>
            {/* 10. Miscellaneous */}
            <section data-id="element-362">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-363">
                10. Miscellaneous
              </h2>
              <div className="space-y-6" data-id="element-364">
                <div data-id="element-365">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-366">
                    10.1 Entire Agreement
                  </h3>
                  <p className="text-gray-600" data-id="element-367">
                    These Terms constitute the entire agreement between you and
                    EndorseHive and supersede all prior agreements or
                    understandings.
                  </p>
                </div>
                <div data-id="element-368">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-369">
                    10.2 Assignment
                  </h3>
                  <p className="text-gray-600" data-id="element-370">
                    You may not assign or transfer your rights or obligations
                    under these Terms without EndorseHive's prior written
                    consent.
                  </p>
                </div>
                <div data-id="element-371">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-372">
                    10.3 Severability
                  </h3>
                  <p className="text-gray-600" data-id="element-373">
                    If any provision of these Terms is found to be invalid or
                    unenforceable, such provision shall be severed and the
                    remaining provisions shall remain in full force and effect.
                  </p>
                </div>
                <div data-id="element-374">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-375">
                    10.4 Entire Agreement
                  </h3>
                  <p className="text-gray-600" data-id="element-376">
                    These Terms constitute the entire agreement between you and
                    EndorseHive and supersede all prior agreements or
                    understandings.
                  </p>
                </div>
              </div>
            </section>
            {/* 11. Contact Us */}
            <section data-id="element-377">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-378">
                11. Contact Us
              </h2>
              <p className="text-gray-600" data-id="element-379">
                For questions about these Terms or your participation, please
                email us at:{" "}
                <a href="mailto:support@endorsehive.com" className="text-emerald-600 hover:text-emerald-700" data-id="element-380">
                  support@endorsehive.com
                </a>
              </p>
            </section>
            {/* 12. Contact Us */}
            <section data-id="element-381">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-382">
                12. Contact Us
              </h2>
              <p className="text-gray-600" data-id="element-383">
                For questions about these Terms or your participation, please
                email us at:{" "}
                <a href="mailto:support@endorsehive.com" className="text-emerald-600 hover:text-emerald-700" data-id="element-384">
                  support@endorsehive.com
                </a>
              </p>
            </section>
            {/* Disclaimer */}
            <div className="mt-12 p-6 bg-gray-50 rounded-lg border border-gray-200" data-id="element-385">
              <p className="text-gray-600" data-id="element-386">
                <strong data-id="element-387">Disclaimer:</strong> This document is provided for
                informational purposes and does <em data-id="element-388">not</em> constitute legal
                advice. Please consult legal counsel to ensure these Terms &
                Conditions meet all regulatory requirements and align with your
                specific business practices.
              </p>
            </div>
          </div>
        </article>
      </div>
    </section>;
};